import { IUsersControls } from "./IUsersControls";
import { IDataStore, DatabaseKey } from "../../../repository/IDataStore";
import { IAdminApi } from "../AdminApi";
import { Observable, Observer } from "rxjs";
import { IUsersAnalytics, TimeSpan } from "./UsersAnalytics/IUsersAnalytics";
import { IUsersOperations } from "./UsersOperations/IUsersOperations";
import { UsersOperations } from "./UsersOperations/UsersOperations";
import { UsersAnalytics } from "./UsersAnalytics/UsersAnalytics";
import { IOrganisation, IResult, IUser } from "../../../model/ModelTypes";
import { IResultsAnalytics } from "./UsersAnalytics/IResultsAnalytics";
import { isNullOrUndefined } from "util";
import { map, first, flatMap } from "rxjs/operators";
import { ResultsAnalytics } from "./UsersAnalytics/ResultsAnalytics";
import * as _ from "lodash";
import * as moment from 'moment';
export class UsersControls implements IUsersControls {
    private usersOperations: UsersOperations;  
    private users: IUser[];
    public static Build(
        dataStore: IDataStore, 
        api: IAdminApi, 
        organisation: IOrganisation): Observable<IUsersControls> {
        let controls = new UsersControls();
        return api.getAllUsers()
            .pipe(
                first(),
                flatMap(recievedUsers => {
                    controls.users = recievedUsers;
                    controls.usersOperations = new UsersOperations(dataStore, api, organisation, recievedUsers);
                    return dataStore.insertDocument(recievedUsers, DatabaseKey.users);
                }),
                map(() => {
                    return controls;
                })
            );
    }
    getOperations(): IUsersOperations {
        return this.usersOperations;
    }
    getAnalytics(): Observable<IUsersAnalytics> {
        return  UsersAnalytics.Build(this.users);
    }
    getResultsAnalytics(span: TimeSpan, month?: number, year?: number): Observable<IResultsAnalytics> {
        return this.mapUsersToResults(this.users, span, month , year)
            .pipe(
                first(),
                map(results => new ResultsAnalytics(results))  
            );
    }

    private mapUsersToResults(users: IUser[], span: TimeSpan, month?: number, year?: number): Observable<IResult[]> {
        return Observable.create((observer: Observer<IResult[]>) => {
            let results: IResult[] = [];
            users.forEach(
                user => {
                    if (!isNullOrUndefined(user.results)) {
                        user.results.forEach(
                            result => {
                                let modifiedResult = _.cloneDeep(result);
                                if (!isNullOrUndefined(user.username)) {
                                    modifiedResult.username = user.
                                                            username.
                                                            replace(`${user.organisation.toUpperCase()}-`, "");
                                }
                                if (!isNullOrUndefined(user.id)) {
                                    modifiedResult.userId = user.id;
                                }
                                let resultDate = moment(result.submit_time).toDate();
                                if (!isNullOrUndefined(user.groups) && user.groups.length > 0) {
                                    modifiedResult.groupName = user.groups[0].name;
                                }
                                if (span === TimeSpan.ALL
                                    || span === TimeSpan.MONTH && resultDate.getMonth() === month 
                                        && resultDate.getFullYear() === year 
                                    || span === TimeSpan.YEAR && resultDate.getFullYear() === year) {
                                    results.push(modifiedResult);
                                }
                            }
                        );
                    }
                }
            );
            observer.next(results);
            observer.complete();
        });
    }

    private constructor() {
        
    }
}


// WEBPACK FOOTER //
// ./src/utility/admin/UsersControls/UsersControls.ts